/**
 * Give browser and assistive-technology focus handoff a moment to settle
 * before deciding that reorder focus truly left the widget. Without this
 * small delay, Chrome + NVDA can briefly report `body`/container focus during
 * DOM reordering or focus restoration and cause a false cancel.
 */
export const REORDER_FOCUS_SETTLE_DELAY_MS = 50;

/**
 * Repeated live-region announcements are more reliable when the region is
 * cleared first and repopulated after a short delay.
 */
export const REORDER_LIVE_REGION_DELAY_MS = 50;
